import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    w-4
    text-[#EA7315]
  `,
});
